// extracted by mini-css-extract-plugin
export default {"home_main":"Home_home_main__wrZIN","postDetails_container":"Home_postDetails_container__ivsgc","posts_container":"Home_posts_container__ijwGO"};